"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlFormComponent = void 0;
class HtmlFormComponent {
    constructor(basePlugin) {
        this.basePlugin = basePlugin;
    }
    addForm(formBuilder) {
        formBuilder.addTextarea("HTML Code:", "htmlInput", true);
    }
    addEditSongForm(formBuilder, metadata) {
        formBuilder.addTextarea("HTML Code:", "htmlInput", true, input => input.value = metadata.value["html"]);
    }
    saveSong(formData, metadata) {
        metadata.value["html"] = formData.htmlInput;
        return true;
    }
}
exports.HtmlFormComponent = HtmlFormComponent;
//# sourceMappingURL=HtmlFormComponent.js.map